import dynamic from "next/dynamic";
import { Suspense } from "react";
import Head from "next/head";
import BlogController from "../../controller/blog.controller";
import { GetServerSideProps, NextPage } from "next";
import { useRouter } from "next/router";

const Bar = dynamic(import("../../components/Blog/Bar"), { suspense: true });
const Card = dynamic(import("../../components/Blog/Card"), { suspense: true });
const Pagination = dynamic(import("rc-pagination"), { suspense: true });

export interface IBlogsProps {
  blog: any;
  categories: any;
}

const Blogs: NextPage<IBlogsProps> = ({ blog, categories }) => {
  const router = useRouter();

  return (
    <>
      <Head>
        <title>
          Latest Trends of Ontario Real Estate market on Bungalow Finder
        </title>
        <meta
          name="title"
          property="og:title"
          content="Latest Trends of Ontario Real Estate market on Bungalow Finder"
        />
        <meta
          name="description"
          property="og:description"
          content="lStay updated with the latest trends in the Ontario real estate market. Explore insightful analysis and valuable information with Bungalow Finder. "
        />
        <meta
          name="keywords"
          content="properties for sale,houses to rent,property for sale,link house for sale,new properties for sale,private property rentals,property for sale in canada,cottage house for sale,property for sale deals,bungalow for sale,detached house for sale,duplex house for sale,bungalows for sale,semi detached house for sale,houses for sale in toronto canada,house for rent in mississauga,mississauga rentals,Rentals in Mississauga,rental apartments in mississauga,realtors in mississauga,townhouse for rent mississauga,bungalows for rent in mississauga"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://bungalowfinder.ca/blogs`} />
        <meta
          property="og:image"
          content="https://bungalowfinder.ca/bungalow-color-logo.png"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image:alt"
          content="Latest Trends of Ontario Real Estate market on Bungalow Finder"
        />{" "}
      </Head>
      <>
        <div className="bg-gray-200 border-b border-gray-200">
          <Suspense fallback={<>Loading ...</>}>
            <div className="container mx-auto">
              <Bar categories={categories} />
            </div>
          </Suspense>
        </div>

        <div className="bg-gray-100">
          <div className="container mx-auto py-3 text-center md:text-left">
            <h1 className="text-xl font-normal">Bungalow Finder Blogs</h1>
          </div>
          <hr />
          <section className="container mx-auto py-5">
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
              <Suspense
                fallback={
                  <>
                    <p>Loading...</p>
                  </>
                }
              >
                {blog.data.length != 0 ? (
                  blog.data.map((item: any) => (
                    <Card key={item.id} item={item} />
                  ))
                ) : (
                  <></>
                )}
              </Suspense>
            </div>
          </section>
          <div className="text-center w-full pb-5">
            <Suspense
              fallback={
                <>
                  <p>Loading...</p>
                </>
              }
            >
              <Pagination
                pageSize={9}
                total={blog.total}
                onChange={(e) => {
                  router.push({
                    pathname: "/blogs",
                    query: { page: e },
                  });
                }}
              />
            </Suspense>
          </div>
        </div>
      </>
    </>
  );
};

export default Blogs;
export const getServerSideProps: GetServerSideProps = async (context) => {
  return await BlogController(context);
};
